import { render } from "./VisitModalTasksPart.vue?vue&type=template&id=1979986b&scoped=true"
import script from "./VisitModalTasksPart.vue?vue&type=script&lang=js"
export * from "./VisitModalTasksPart.vue?vue&type=script&lang=js"

import "./VisitModalTasksPart.vue?vue&type=style&index=0&id=1979986b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1979986b"]])

export default __exports__